export type LoadingStatus = 'Loading' | 'LoadingPartial' | 'Error' | 'Success';

export const LoadingStatus = {
  Idle: 'Idle' as LoadingStatus,
  Loading: 'Loading' as LoadingStatus,
  LoadingPartial: 'LoadingPartial' as LoadingStatus,
  Error: 'Error' as LoadingStatus,
  Success: 'Success' as LoadingStatus,
};
